 let state = {
     rebates: [],
     statuses: [],
     customers: [],
     mvpdinfo: [],
     currentRebate: {},
     errors: {},
     billsRequired: 3,
     sliderStep: 0,
     showSlider: false,
     providers: [
         'Ace Communications',
         'AcenTek',
         'Adams Cable TV',
         'Alpine Communications',
         'Americable International Inc.',
         'Americable',
         'Antietam Cable Television',
         'Armstrong',
         'Astound powered by enTouch',
         'Astound powered by Grande',
         'Astound powered by RCN',
         'Astound powered by Wave Broadband',
         'Auburn Essential Services',
         'Ballard Television',
         'BEAM (Cable TV of East Alabama)',
         'Beehive Broadband',
         'Ben Lomand/BLTV',
         'Bend Cable',
         'Blue Ridge',
         'Blue Stream',
         'Bolt Fiber (Northeast Rural)',
         'Brandenburg Telephone Company',
         'Breezeline',
         'Broadstar',
         'BTC Communications',
         'BTES (Bristo l Tennessee Essential Services)',
         'Buckeye',
         'Cable Systems of Nevada',
         'CATC (Central Arkansas Telephone Cooperative)',
         'CDE Lightband',
         'Celect Communications',
         'Champaign IPTV',
         'Chariton Valley Communications',
         'Cherokee Telephone Company',
         'Cincinnati Bell (now altafiber)',
         'Citizens Cablevision Corp',
         'Citizens Mutal Telephone Coop',
         'City of Bardstown',
         'City of Bellevue',
         'City of Highland',
         'CL Tel',
         'Clarity Telecom',
         'Community Cable & Broadband',
         'Co-Mo Connect',
         'Compas X-Stream',
         'Comporium',
         'Consolidated Communications',
         'Consolidated Telephone Company',
         'Consolidated Telephone Company',
         'Craigville Telephone Company',
         'Crosslake Communications',
         'Cumberland Connect',
         'D&P Communications',
         'Delcambre',
         'Eagle Lake',
         'Easton Utilities',
         'Emily Cooperative Telephone',
         'Endeavor Communications',
         'EPB Fiber Optics',
         'Falcon1',
         'Fidelity Communications',
         'FJ Communications',
         'FOCUS Broadband/ATMC',
         'Frankfort Plant Board',
         'FTC Diversified ',
         'Garden Valley Technologies',
         'Garden Valley Telephone Company',
         'Gardonville Cooperative Tele.',
         'GCI Cable',
         'Genuine Telecom',
         'Geus',
         'Glasgow Electric Plant Board',
         'Gold Coast Broadband',
         'Greenhills Communications',
         'Greenlight Community Broadband',
         'GVTC Communications',
         'Hardy Telecommunications',
         'Hargray',
         'Hawaiian Telcom',
         'HBC',
         'Heart of Iowa Comms Cooperative',
         'Highland Media',
         'Highlands Cable Group',
         'Hilltop Communications',
         'Horizon Chillicothe',
         'HTC Communications IL',
         'HTC Digital Cable',
         'Industry I-Net',
         'Inter Mountain Cable ',
         'Interstate Telecommunications',
         'ITV-3',
         'Jefferson County Cable',
         'Kalida',
         'Kaptel',
         'La Porte City Telephone',
         'LaValle Telephone Cooperative',
         'LHTC Broadband',
         'Liberty',
         'Long Lines',
         'Lumos Networks',
         'LUS Fiber',
         'Mahaska Communications ',
         'MaxxSouth Broadband',
         'MCTV',
         'Mediacom',
         'MetroNet',
         'MHTC (MH Telcom)',
         'MIDTEL',
         'Milford Communications',
         'MLGC',
         'Moonbeam Communications',
         'Mountain Rural Telephone Co-op',
         'MTCO Communications',
         'Mulberry Cooperative Telephone',
         'Mutual Telephone Company',
         'NDTC (North Dakota Telephone Company)',
         'Netsync/DFT',
         'New Wave',
         'Nex-Tech',
         'NK Telco',
         'Nortex Communications',
         'North Central Communications',
         'North State Communications',
         'Northern Iowa Comm Partners',
         'Northland Communications',
         'Northwest Fiber',
         'Norvado',
         'Norvado',
         'OEC FIber',
         'Orbitel Communications',
         'OTEC Communications',
         'OzarksGO',
         'Panora Cooperative Cablevision',
         'Paul Bunyan',
         'People\'s Rural Telephone Co-Op',
         'Phonoscope',
         'Pine Belt Communications',
         'Polar Communications',
         'Premier Communications',
         'Price County Telephone Co.',
         'QXC Communications',
         'Ralls Technologies, LLC',
         'Real Choice',
         'Reedsburg',
         'Reservation Telephone Co-op',
         'REV (EATEL Westside)',
         'REV (EATEL)',
         'REV (Reserve Telecommunications)',
         'REV (Vision Communications)',
         'Richland Grant',
         'Rock Port Cablevision',
         'Route 66 Broadband',
         'RTA America',
         'Salsgiver Communications',
         'Sand Creek Telephone Company',
         'Scranton Telephone',
         'Service Electric Cable TV Hunterdon',
         'Service Electric Cable TV Lehigh Valley',
         'Service Electric Cable TV Wilkes Barre',
         'Service Electric Cablevision',
         'Shentel',
         'Shrewsbury Electric & Cable',
         'Sister Lakes Cable',
         'Skitter TV',
         'SkyBest Communications',
         'Slic Network Solutions',
         'SMU (Spencer Municipal Utilities)',
         'Socket Telecom',
         'Solarus',
         'South Central Telecom',
         'Southern Fibernet Corporation',
         'Sparklight',
         'Star Communications (Starvision)',
         'StratusIQ',
         'Summit Broadband',
         'Surry Telecommunications',
         'Sycamore Telephone Company',
         'TDS Telecom',
         'TeleGuam Holdings',
         'Three River',
         'Town and Country Technologies',
         'Tullahoma Utilities Board',
         'Twin Lakes Communications, Inc.',
         'Twin Valley Communications',
         'United Services',
         'USA Communications',
         'Vast Broadband',
         'Verizon Fios',
         'Vexus Fiber',
         'Viya',
         'VNET Fiber',
         'Vyve Broadband',
         'Wabash Mutual Telephone',
         'Waldron Communication Company ',
         'Waverly Communications Utility',
         'West Central Telephone',
         'West Kentucky Rural Telephone',
         'WesTel Systems',
         'Western Iowa Network',
         'Wilkes Communications',
         'Williamstown Cable TV',
         'Williamstown Cable',
         'Wood County Telephone Company',
         'WOW',
         'Wyandotte CAble',
         'Wyandotte Municipal Service',
         'Yelcot Communications',
         'Ziply Fiber'
     ]
 }

 export default state
